export default "__VITE_ASSET__ChLbzQpp__"